export default function Problems() {
  const painItems = [
    { icon: "ri-bank-line", label: "Conta bloqueada de surpresa" },
    { icon: "ri-money-dollar-circle-line", label: "Salário ou aposentadoria bloqueados" },
    { icon: "ri-scales-3-line", label: "Bloqueio maior que o valor da dívida" },
    { icon: "ri-building-2-line", label: "Conta da empresa bloqueada" },
    { icon: "ri-file-text-line", label: "Bloqueio em execução fiscal" },
    { icon: "ri-briefcase-line", label: "Bloqueio em ação trabalhista ou cobrança judicial" },
  ];

  const unlockCriteria = [
    { icon: "ri-user-line", label: "Valores de natureza salarial" },
    { icon: "ri-shield-line", label: "Benefícios previdenciários" },
    { icon: "ri-heart-line", label: "Pensão ou aposentadoria" },
    { icon: "ri-scales-3-line", label: "Bloqueio excessivo ou desproporcional" },
    { icon: "ri-home-line", label: "Conta usada para subsistência" },
    { icon: "ri-alert-line", label: "Irregularidades no processo" },
    { icon: "ri-close-circle-line", label: "Cobrança discutível ou indevida" },
  ];

  const origins = [
    { icon: "ri-government-line", label: "Execução fiscal", desc: "Cobranças de tributos por Municípios, Estados ou União Federal" },
    { icon: "ri-file-list-3-line", label: "Cumprimento de sentença", desc: "Decisão judicial já transitada em julgado sendo executada" },
    { icon: "ri-newspaper-line", label: "Execução de título extrajudicial", desc: "Cheques, contratos e outros títulos com força executiva" },
    { icon: "ri-briefcase-line", label: "Ação trabalhista", desc: "Decisões da Justiça do Trabalho em fase de execução" },
    { icon: "ri-bank-card-line", label: "Cobranças judiciais em geral", desc: "Qualquer ação de cobrança em fase executiva" },
  ];

  return (
    <section id="areas-atuacao" className="bg-white">
      {/* Seção 1: Identificação da Dor */}
      <div className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-14">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Você está passando por alguma dessas situações?
            </h2>
            <p className="text-lg text-gray-500 max-w-2xl mx-auto">
              Reconheça a sua situação. Cada uma delas pode ter solução jurídica.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {painItems.map((item, index) => (
              <div
                key={index}
                className="flex items-center gap-4 bg-white border border-gray-200 rounded-xl px-6 py-5 hover:border-amber-400 transition-colors duration-200"
              >
                <div className="w-11 h-11 flex items-center justify-center bg-red-50 rounded-lg shrink-0">
                  <i className={`${item.icon} text-xl text-red-600`}></i>
                </div>
                <p className="text-gray-800 font-medium text-sm leading-snug">{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Seção 3: Origem do bloqueio */}
      <div className="py-20 bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-14">
            <h2 className="text-3xl md:text-4xl font-bold mb-5">
              O bloqueio judicial pode surgir em diferentes tipos de processo
            </h2>
            <p className="text-lg text-gray-400 max-w-2xl mx-auto">
              Independentemente da origem, o escritório atua tanto no pedido de desbloqueio quanto na defesa do processo que originou a medida.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-5 mb-12">
            {origins.map((origin, index) => (
              <div key={index} className="bg-gray-800 rounded-xl p-6 text-center hover:bg-gray-700 transition-colors duration-200">
                <div className="w-12 h-12 flex items-center justify-center bg-amber-500/20 rounded-full mx-auto mb-4">
                  <i className={`${origin.icon} text-xl text-amber-400`}></i>
                </div>
                <h3 className="text-white font-semibold text-sm mb-2">{origin.label}</h3>
                <p className="text-gray-400 text-xs leading-relaxed">{origin.desc}</p>
              </div>
            ))}
          </div>

          <div className="bg-amber-500/10 border border-amber-500/30 rounded-2xl p-8 text-center max-w-3xl mx-auto">
            <i className="ri-scales-3-line text-3xl text-amber-400 mb-4 block"></i>
            <p className="text-white text-lg font-semibold mb-2">
              Atuação completa: bloqueio e processo de origem
            </p>
            <p className="text-gray-400 text-sm leading-relaxed">
              Não basta apenas pedir o desbloqueio. Em muitos casos, é essencial questionar a legalidade do próprio processo que originou a medida — especialmente em execuções fiscais.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
